import { render } from "./InvalidateProfileAlert.vue?vue&type=template&id=48938b1e"
import script from "./InvalidateProfileAlert.vue?vue&type=script&lang=js"
export * from "./InvalidateProfileAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__